import { setLoading, setGlobalMessage } from '../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../api_exception';

const BASE_PATH = "COMPANY_USERS";

export const loadUsers = (rowsPerPage = null, page = null) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        let state = getState().COMPANY_USERS;
        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        client.post('/company/users', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.users) {
                    dispatch(setUsersData(result.data.users,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const deleteUser = (userId) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        let state = getState().COMPANY_USERS;

        client.delete(`/company/user/delete/${userId}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage, ALERT_SEVERITY.SUCCESS));
                    dispatch(loadUsers(state.rowsPerPage, 0));
                } else {
                    dispatch(setLoading(false));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const SET_USERS_DATA = `${BASE_PATH}/SET_USERS_DATA`;
export const SET_ADD_NEW_USER = `${BASE_PATH}/SET_ADD_NEW_USER`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setUsersData = (users, page, rowsPerPage, totalRows) => ({
    type: SET_USERS_DATA,
    users,
    page,
    rowsPerPage,
    totalRows
});

export const setAddNewUser = (isAddNewUser) => ({
    type: SET_ADD_NEW_USER,
    isAddNewUser
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    users: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,
    isAddNewUser: false,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_USERS_DATA:
            let newState = {
                ...state,
                users: [...action.users],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_ADD_NEW_USER:
            return {
                ...state,
                isAddNewUser: action.isAddNewUser
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}